module.exports = __webpack_public_path__ + "static/media/Viva_Color_lema.366c6c09.png";